module.exports = __webpack_public_path__ + "static/media/doctor.b7d9c9e6.png";